module.exports = __webpack_public_path__ + "img/logo_factura.9c8a165e.png";